import { Component, OnInit, Input } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

// ------------------------------------------------------
export interface IButtonControl {
  loading: boolean;
  disabled: boolean;
  error: string;
}

@Component({
  selector: 'smartbutton',
  template: require('./smartbutton.component.pug'),
  styles: [require('./smartbutton.component.css').toString()],
})
export class SmartButtonComponent implements OnInit {
  @Input('title')
  title: string;
  @Input('data')
  data: any;
  @Input('onclick')
  onclick: onSmartButtonCallback;
  @Input('controller')
  controller: IButtonControl;
  @Input('confirm')
  confirm: boolean = false;
  @Input('extraclass')
  extraclass: string = '';
  @Input('disabled')
  disabled: boolean = false;

  @Input('reset')
  reset: Subject<boolean> = null;

  error: boolean = false;
  errorText: string = '';
  loading: boolean = false;
  sub: Subscription = null;

  // -------------------------------------------------------------------
  constructor() {}

  // -------------------------------------------------------------------
  ngOnInit() {
    /*
    console.log('title');
    console.log(this.title);
    console.log('data');
    console.log(this.data);
    */
    if (this.reset) {
      this.sub = this.reset.subscribe(_ => {
        this.loading = false;
      });
    }
  }

  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }

  // -------------------------------------------------------------------
  onSuccess() {
    this.loading = false;
    //console.log('onSuccess!');
  }

  // -------------------------------------------------------------------
  onFailure(error: string) {
    this.error = true;
    this.errorText = error;
    this.loading = false;
  }

  // -------------------------------------------------------------------
  clicked() {
    this.error = false;
    this.errorText = '';
    this.loading = true;
    //console.log('* clicked *');
    this.onclick(
      this.data,
      this.onSuccess.bind(this),
      this.onFailure.bind(this),
    );
  }
}
